/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBookingSingleMutationRequest, PostApiBookingSingleMutationResponse, PostApiBookingSingleQueryParams } from "../entities/PostApiBookingSingle";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBookingSingle } from "../api/postApiBookingSingle";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBookingSingleMutationKey = () => [{ url: '/api/booking/single' }] as const

export type PostApiBookingSingleMutationKey = ReturnType<typeof postApiBookingSingleMutationKey>

export function postApiBookingSingleMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PostApiBookingSingleMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = postApiBookingSingleMutationKey()
        return mutationOptions<PostApiBookingSingleMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingSingleMutationRequest, params: PostApiBookingSingleQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ data, params }) => {
            return postApiBookingSingle(data, params, config)
          },
        })

}

/**
 * @description Создание новой записи на стрижку
 * @summary Создать запись
 * {@link /api/booking/single}
 */
export function usePostApiBookingSingle<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBookingSingleMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingSingleMutationRequest, params: PostApiBookingSingleQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostApiBookingSingleMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBookingSingleMutationKey()

          const baseOptions = postApiBookingSingleMutationOptions(config) as UseMutationOptions<PostApiBookingSingleMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingSingleMutationRequest, params: PostApiBookingSingleQueryParams}, TContext>
          

          return useMutation<PostApiBookingSingleMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingSingleMutationRequest, params: PostApiBookingSingleQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBookingSingleMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingSingleMutationRequest, params: PostApiBookingSingleQueryParams}, TContext>
      
}